import { ButtonPresentationProps } from "@insite/mobius/Button";
import { DataTableProps } from "@insite/mobius/DataTable";
import { DataTableCellProps } from "@insite/mobius/DataTable/DataTableCell";
import { DataTableHeaderProps } from "@insite/mobius/DataTable/DataTableHeader";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { pxToRem } from "@store/Framework/Common/Utilities/unitHelper";
import { CheckboxPresentationProps } from "@store/MobiusOverrides/Checkbox/Checkbox";
import { LinkPresentationProps } from "@store/MobiusOverrides/Link/Link";
import { RadioGroupProps } from "@store/MobiusOverrides/RadioGroup/RadioGroup";
import { TypographyProps } from "@store/MobiusOverrides/Typography/Typography";
import { ProductImageStyles } from "@store/Overrides/Components/ProductImage";
import { WishListSharingStatusStyles } from "@store/Overrides/Components/WishListSharingStatus";
import { focusUpdateStyles } from "@store/Themes/common/mixins/common";
import { imageStyles } from "@store/Themes/common/mixins/image";
import { productLineProps } from "@store/Themes/common/props/productLine";
import { tableGetEllipsisCellProps, tableProps } from "@store/Themes/common/props/table";
import { css } from "styled-components";

export interface WishListTableProps {
    wrapper?: InjectableCss;
    dataTable?: DataTableProps;
    iconCell?: DataTableCellProps;
    listNameHeader?: DataTableHeaderProps;
    listNameDescriptionCell?: DataTableCellProps;
    listDescriptionText?: TypographyProps;
    dateHeader?: DataTableHeaderProps;
    dateCell?: DataTableCellProps;
    lastUpdatedText?: TypographyProps;
    itemsHeader?: DataTableHeaderProps;
    itemsCell?: DataTableCellProps;
    itemsWrapper?: InjectableCss;
    itemsImageWrapper?: InjectableCss;
    itemProductImage?: ProductImageStyles;
    statusHeader?: DataTableHeaderProps;
    statusCell?: DataTableCellProps;
    sharingStatus?: WishListSharingStatusStyles;
    actionsHeader?: DataTableHeaderProps;
    actionsCell?: DataTableCellProps;
    actionsWrapper?: InjectableCss;
    actionButton?: ButtonPresentationProps;
    actionAddToCartLink?: LinkPresentationProps;
    actionLeaveLink?: LinkPresentationProps;
    actionDeleteLink?: LinkPresentationProps;
    actionHideLink?: LinkPresentationProps;
    actionUnhideLink?: LinkPresentationProps;
}

const smallCellProps: DataTableCellProps = {
    css: css`
        padding-top: ${pxToRem(8)};
        padding-bottom: ${pxToRem(8)};
    `,
};

export const wishListTableProps: WishListTableProps = {
    wrapper: tableProps.wrapper,
    dataTable: {},
    iconCell: {
        css: css`
            padding: 0;
        `,
    },
    listNameHeader: {},
    listNameDescriptionCell: tableGetEllipsisCellProps(220),
    listDescriptionText: {},
    dateHeader: {},
    dateCell: tableGetEllipsisCellProps(155),
    lastUpdatedText: {},
    itemsHeader: {},
    itemsCell: smallCellProps,
    itemsWrapper: {
        css: css`
            display: flex;
            gap: ${pxToRem(5)};
        `,
    },
    itemsImageWrapper: {
        css: css`
            ${x => imageStyles(x.theme.design.product.image.small.ratio)}
            width: ${pxToRem(50)};
            flex: 0 0 auto;
        `,
    },
    itemProductImage: {
        linkWrappingImage: {
            css: css`
                ${focusUpdateStyles(true)}
            `,
        },
    },
    statusHeader: {},
    statusCell: tableGetEllipsisCellProps(180),
    sharingStatus: {},
    actionsHeader: tableProps.tightHeader,
    actionsCell: smallCellProps,
    actionsWrapper: {},
    actionButton: tableProps.button,
    actionAddToCartLink: productLineProps.addToListLink,
    actionLeaveLink: productLineProps.leaveListLink,
    actionDeleteLink: productLineProps.removeLink,
    actionHideLink: productLineProps.hideListLink,
    actionUnhideLink: productLineProps.unhideListLink,
};

export interface WishListDetailsProps {
    checkbox?: CheckboxPresentationProps;
    radioGroup?: RadioGroupProps;
}

export const wishListDetailsProps: WishListDetailsProps = {
    checkbox: {
        sizeVariant: "small",
        css: css`
            ${x => x.theme.checkbox.defaultProps?.css as any}
            cursor: pointer;

            @media print {
                display: none;
            }
        `,
    },
    radioGroup: {
        horizontal: true,
        css: css`
            ${x => x.theme.radio.groupDefaultProps?.css}
        `,
    },
};
